import React, { memo, useEffect, useState } from "react";
import styles from "./MostRecentOrderTab.module.scss";
import OrderDetailsSideDialog from "../../../components/OrderDetailsSideDialog/OrderDetailsSideDialog";
import CommonPagination from "../../../../../common/components/pagination/CommonPagination";
import { OrderStatus } from "../../../../../model/orders/orders";
import { toast } from "react-toastify";
import { formatDate } from "../../../../../utils";
import { ProviderCustomerOrder } from "../../../../../model/customer/customer";
import { useGetMostRecentOrdersQuery } from "../../../../../service/solar-provider-service";
type Props = {
	startDate: Date;
	endDate?: Date;
};

const MostRecentOrderTab = memo((props: Props) => {
	const { startDate, endDate } = props;

	const [viewDetails, setViewDetails] = useState(false);
	const [selectedOrder, setSelectedOrder] = useState<ProviderCustomerOrder | undefined>();

	const pageSize = 6;
	const [currentPage, setCurrentPage] = useState(1);

	const [data, setData] = useState<ProviderCustomerOrder[]>([]);

	const { 
		data: ordersData, 
		error: ordersError, 
		isLoading: loading 
	} = useGetMostRecentOrdersQuery({
		page: currentPage,
		pageSize,
		start: startDate,
		end: endDate
	});

	useEffect(() => {
		if (ordersData) {
			setData(ordersData.items);
		}
	}, [ordersData]);

	useEffect(() => {
		if (ordersError && 'data' in ordersError) {
			const errorData = ordersError.data as any;
			toast.error(errorData?.title || "Something went wrong. Please try again.");
		}
	}, [ordersError]);

	const previewDetails = (order: any) => {
		setSelectedOrder(order);
		setViewDetails(true);
	}

	function onUpdatedOrderStatus(orderId: string, newStatus: OrderStatus) {
		const updatedOrders = data.map(order => {
			if (order.id === orderId) {
				return {
					...order,
					status: newStatus
				};
			}
			return order;
		});
		// setData(updatedOrders);
		setSelectedOrder(undefined);
		setViewDetails(false);
	}

	return (
		<section>
			<div className={styles.tableContainer}>
				<table className="standardTable">
					<thead>
						<tr>
							<th>CUSTOMER NAME</th>
							<th>PRODUCT ORDERED</th>
							<th>PAYMENT DATE</th>
							<th>ORDER STATUS</th>
							<th>DATE STATUS CHANGED</th>
							<th>VIEW DETAILS</th>
						</tr>
					</thead>
					<tbody>
						{data.map((order, index) => (
							<tr key={order.id}>
								<td>{order.customerName}</td>
								<td>{order.productName}</td>
								<td>{formatDate(order.paymentDate ?? "")} </td>
								<td>{order.status}</td>
								<td>{formatDate(order.statusChanged ?? "")}</td>
								<td>
									<button className={`actionButton`} onClick={() => previewDetails(order)}>
										VIEW DETAILS
									</button>
								</td>
							</tr>
						))}
					</tbody>
				</table>
			</div>

			<div className={styles.paginationContainer}>
				<CommonPagination
					currentPage={currentPage}
					isLoading={loading}
					numberOfPages={ordersData?.totalPages || 0}
					onPageChange={(page: number) => {
						setCurrentPage(page);
					}}
				/>
			</div>

			{/* {viewDetails && <OrderDetailsSideDialog order={selectedOrder!} onCloseDialog={() => setViewDetails(false)} onUpdateOrderStatus={onUpdatedOrderStatus} />} */}
		</section>
	);
});

export default MostRecentOrderTab;
